/** Prioriza nome social (SED) quando existir; caso contrário nome civil — mesmo critério das demais telas. */
export function nomeExibicaoAluno(a: {
  nomeSocial?: string | null;
  nomeAluno?: string | null;
}): string {
  const s = a.nomeSocial?.trim();
  return s && s.length > 0 ? s : (a.nomeAluno ?? '');
}

/** Iniciais a partir do nome de exibição (palavras com mais de 3 caracteres), alinhado ao detalhe de chamado. */
export function iniciaisNomeExibicao(nome: string): string {
  if (!nome?.trim()) {
    return '';
  }
  return nome
    .split(' ')
    .filter((parte) => parte.length > 3)
    .map((parte) => parte.charAt(0))
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export function enriquecerAlunoComNomeExibicao<T extends { nomeSocial?: string | null; nomeAluno?: string | null }>(
  a: T
): T & { nomeExibicao: string } {
  return {
    ...a,
    nomeExibicao: nomeExibicaoAluno(a),
  };
}
